export default __webpack_public_path__ + "static/media/good.1927d764.gif";